import { default as formBuilderLogic } from './formBuilder';
import { default as formFinderBuilderLogic } from './formFinderBuilder';
import { default as formsLogic } from './forms';
import { default as formFindersLogic } from './formFinders';
import { default as fieldDialogLogic } from './fieldDialog';
import { default as stepDialogLogic } from './stepDialog';
import { default as siteLogic } from './site';

export default [
    ...fieldDialogLogic,
    ...formBuilderLogic,
    ...formFinderBuilderLogic,
    ...formsLogic,
    ...formFindersLogic,
    ...stepDialogLogic,
    ...siteLogic,
];
